import type { RelatedNewsItem } from 'hb-react/shared/apps/News/types';
import { axiosWithSyntaxHandlers as axios } from 'hb-react/shared/utils/axios';

export interface GetRelatedNewsRequestProps {
  groupId?: string;
  newsId: string;
  signal?: AbortSignal;
}

export const getRelatedNewsRequest = ({
  groupId,
  newsId,
  signal,
}: GetRelatedNewsRequestProps) => {
  const path = groupId
    ? Routes.private_publicoffice_topics_news_related_items_path(
        groupId,
        newsId,
      )
    : Routes.private_publicoffice_news_related_items_path(newsId);

  return axios.get<{ data: RelatedNewsItem[] }>(path, {
    signal,
  });
};
